<template>
  <div>
   
     
    <div v-show="!minimizeNavBar" >
  <nav class="navbar  is-primary is-fixed-top" role="navigation" aria-label="main navigation" style="height:60px">
    <div class="navbar-brand">
      
      <a  v-on:click="home" v-show="club==null">
        <img src="@/assets/logoMenu.png" class="logo" />
      </a>
      
           
      
      <a v-if="club!=null" >
        <div class="logoClub" v-if="pathFile!=null">
          <div class="logoDim">
            <img-file 
                :ref="'F'+club.id" 
                :pathFile="pathFile" 
                width="50px" 
                height="70%" :role="getRole()"
                @onclick="upload('/club/',club.id)"
                @finish="uploadInProgress = false" 
                :upload="false"
                :exists="club.logo ? true : false"/>
          </div>
        </div>
                
      </a>
      <div class="g_mobileOn" v-if="club">{{club.name}} </div>
      <a
          id="example-burger"
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="main-menu"
          
          v-on:click="activeBurger=='is-active' ? activeBurger='' : activeBurger='is-active'"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <s-arrow id="concours" v-if="activeBurger!='is-active'"/>
        <s-arrow id="saisons" v-if="activeBurger!='is-active'"/>
        <s-arrow id="membres" v-if="activeBurger!='is-active'"/>
      </a> 
    
    </div>

    <div id="main-menu" :class="'navbar-menu menuMobileBurger '+activeBurger" v-if="$store.getters.getUser">
       
       <div class="navbar-end">
         <div class="navbar-item itemMenu"  v-show="$isAnonyme()">  
            <a v-on:click="goSearchClub"  :class="nav==-2 ? 'selectedOnglet' : 'songlet2'">Rechercher</a>
         </div> 
         <div class="navbar-item itemMenu"  v-show="club!=null">  
            <a v-on:click="goViewClub" :class="nav==-1 ? 'selectedOnglet' : 'songlet2'">Mon Club</a>
          </div> 
          <div class="navbar-item itemMenu"  v-show="club!=null">  
            <a v-on:click="goConcours" :class="nav==0 ? 'selectedOnglet' : 'songlet2'">Concours</a>
              <s-arrow id="concours"/>
          </div>   
          <div class="navbar-item itemMenu" v-show="club!=null">  
            <a v-on:click="goSaison" :class="nav==1 ? 'selectedOnglet' : 'songlet2'">Saisons</a>
              <s-arrow id="saisons"/>
          </div>   
          <div class="navbar-item itemMenu" v-show="club!=null" v-if="$getRole()=='admin' || $getRole()=='owner'">  
            <a v-on:click="goMembres" :class="nav==2 ? 'selectedOnglet' : 'songlet2'">Membres</a>
              <s-arrow id="membres"/>
          </div>   
          <div class="navbar-item itemBarre" v-show="club!=null" v-if="isNotVisiteur">  
          </div> 
          <div class="navbar-item itemMenu" v-if="!$isAnonyme()">      
            <a v-on:click="goClub" class="songlet">Mes clubs</a>
          </div>
          <div class="navbar-item itemMenu" v-if="!$isAnonyme()">      
            <a v-on:click="payment" class="songlet">
              <span class="icon has-text-success clignote is-large" v-if="receptCredit>0">
                 <i class="fas fa-gift"/>
              </span>
              Crédit : {{credit}}
            </a>

          </div>  
          <div class="navbar-item itemMenu" v-if="!$isAnonyme()">    
            <div  v-on:click="profil" class="profil">
              <img v-if="profilImg!=null" :src="profilImg" class="profilImg"/>  
              <s-button icon="user" theme="is-info" label="" v-if="profilImg==null" id="profil"/>
              <div class="profilItem">{{$store.getters.getUser.displayName}}
             
              </div>
            </div>
          </div>
          <div class="navbar-item itemMenu" v-if="$isAnonyme()">  
            <s-button icon="times" theme="is-danger is-medium" label="" @onclick="logout()" id="logout"/>
          </div>
      </div>
    </div>
  </nav>
    </div>
    <div class="sheader" v-show="!minimizeNavBar">&nbsp;
     </div>
     
  </div>
</template>
<style  scoped>
  .clignote  {
    animation-duration: .8s;
    animation-name: clignoter;
    animation-iteration-count: infinite;
    transition: none;
  }
  @keyframes clignoter {
    0%   { opacity:1; }
    40%   {opacity:0; }
    100% { opacity:1; }
  }
 .sheader {
    height: 70px;
    margin-bottom: 10px;
  }
 
 .minimize {
   height: 25px;
   background-color: var(--bluebg);
   text-align:center;
   color: white;
   font-size: 14px;
   padding-top: auto;
   padding-bottom: auto;
 }
 .minimize:hover {
   cursor: pointer;
 }
 
@media screen and (max-width: 420px) {
  .selectedOnglet {
    
    
    vertical-align: middle;
    height: 70px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 20px;
    
    font-weight: bolder;
  } 
  .clubName {
    display: inline-block;
    color: white;
    padding-left: 20px;
    vertical-align: top;
    padding-top: 5px;
    font-size: 16px;
    font-weight: bolder;
    
  }
  .minimizeNotMobile {
    display: none;
  }
   .minimizeMobile {
    font-size: 20px;
    color: var(--bluebg);
    font-weight: bolder;
  }
  .menuMobileBurger {
        background-color: #FFD75C;
        height: 700px;
        padding-top: 20px;
        text-align: center;
        color: var(--bluebg);
  }
   .songlet2 {
       padding:5px;
      color: var(--bluebg);
      font-weight: bolder;
    
  }
  .songlet {
      color: var(--bluebg);
     
      font-weight: bolder;
  }
  .profil {
    color: var(--bluebg);
    vertical-align: center;
    padding: 5px;
    text-align: center;
    border-radius: 10px;
  }
  
  .itemBarre {
    border-bottom: dashed white thick;
    margin-left: 50px;
    margin-right: 50px;
   
  }
  
  .itemMenu {
    width: 150px;
    margin-left: auto;
    margin-right: auto;
  }

}
@media screen and (min-width: 420px) {
  .selectedOnglet {
    background-color: #f4f5fa;
    color: var(--bluebg);;
    vertical-align: middle;
    height: 70px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 20px;
    font-size: 18px;
    font-weight: bolder;
  } 
  .clubName {
    display: inline-block;
    left: 0px;
    top: 40px;    
    font-weight: bolder;
    position: fixed;
    background-color: var(--bluebg);
    height: 40px;
    width: 100%;
    padding-top: 15px;
    padding-left: 80px;
    padding-right: 70px;
    color: white;
    transform-origin: bottom left;
    z-index: -1;
  }
  
  .minimizeMobile {
    display: none;
  }
  .menuMobileBurger {
        
  }
  .songlet {
    color: white;
    
    font-weight: bolder;
    
  }
   .songlet:hover {
    color: #FFD75C;
    cursor:pointer;
    border-radius: 10px;
    text-align: center;
  }
  .songlet2 {
    color: white;
    
    font-weight: bolder;
    padding:5px;
  }
   .songlet2:hover {
    color: #FFD75C;
    cursor:pointer;
    border-radius: 10px;
    text-align: center;
  }
  .profil {
    color: white;
    vertical-align: center;
    padding: 5px;
    text-align: center;
    
  }
  
  .itemBarre {
    
    border-right: dashed white thick;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  
  .itemMenu {
     margin-left: 40px;
    font-size: 18px;
   
  }
}
  .thumbtack {
    position: absolute;
    top: 50px;
    right: 10px;
    z-index: 200;
    margin-left: 5px;
  }
  .thumbtackH {
   position: absolute;
    top: 5px;
    right: 10px;
    z-index: 200;
    margin-left: 5px;
 }
  
  .logo {
    width: 100px;
    margin-left: 10px;
    padding-top: 5px;

  }
  
  
  .profilImg {
    border-radius: 20px;
  }
  
  .profilItem {
    
  }
  .profil:hover {
     background-color: #f4f5fa;
    color: var(--bluebg);
    cursor:pointer;
    
  }
  .logoClub {
    display: inline-block;
    text-align:center;
    vertical-align: middle;
    border-radius: 10px;
    margin: 1px;
    margin-left: 10px;
  }
  .logoDim {
    display: table-cell;
    vertical-align: middle;
    height: 100%;
    padding: 5px;
  }
	
</style>
<script>
import firebase from "firebase";
import firebase_api from "@/firebase/firebase_api"
import club_fct         from '@/firebase/club'

import imgUpload from '@/components/imgUpload.vue'
import imgFile from '@/components/imgStore.vue'
export default {
  props: ["idClub"],
   components: {
        imgUpload,
        imgFile
    },
  name: "my-navbar",
  data() {
    return {
      club: null,
      activeBurger:'',
      saison: null,
      historiques: []
    }
  },
  computed: {
    userFirebase: {
      get() {
        return firebase.auth().currentUser
      }
    },
    receptCredit: {
            get() {
                var recept = 0;
                this.historiques.forEach(item=>{
                    if (item.state == null && item.recept)
                        recept += parseInt(item.credit);
                })
                return recept;
            }
    },
    isNotVisiteur() {
        return this.$getRole() != "visiteur";
    },
    idSeason: {
      get() {
        
        if (typeof(this.$route.params.idSeason)!="undefined")
          return this.$route.params.idSeason;
        else 
          return null;
      }
    },
    nav: {
      get() {
        if (this.$route.name == 'visit')
          return -2;
        if (this.$route.name == 'viewClub')
          return -1;
        if (this.$route.name == 'concours')
          return 0;
        else if (this.$route.name == 'saison' || this.$route.name == 'tournoisSeason') {
          return 1;
        }
        else if (this.$route.name == 'membres' || this.$route.name == 'demandes')
          return 2;  
        else
          return null;
      }
    },
    minimizeNavBar:{
      get() {
        return this.$store.getters.getMinimize;
      },
      set(val) {
        this.$store.dispatch("setMinimize", {
          value: val
        })
      }
    },
    pathFile() {
        if (this.club.length!=0) {
              var url = '/club/'+this.club.id;
              return url;
          }
          return null;
      },
    profilImg: {
      get() {
        return firebase.auth().currentUser.photoURL
      }
    },
    credit: {
      get() {
        var subscription = false;
        if (this.$store.getters.getCredit!=null)
          return this.$store.getters.getCredit.credit
        return 0;
      }
    }
  },
  watch: {
    idClub: {
      immediate: true,
      handler(val) {
        if (typeof(val)=="undefined")
          this.club = null;
        else {
          this.$bind("club", firebase_api.api.getDb().collection('club').doc(val))
        }
      }
    },
    idSeason: {
      immediate: true,
      handler(val) {
        if (typeof(val)=="undefined")
          this.saison = null;
        else {
          if (this.idSeason != null)
            this.$bind("saison", firebase_api.api.getDb().collection('club').doc(this.club.id).collection("saisons").doc(this.idSeason))
          else
            this.saison = null;
        }
      }
    }
  },
  methods: {
    tutoset(name) {
      this.$tuto(name, true, name);
    },
    profil: function() {
     
      if (this.club==null)
        this.$router.push({name: "profil"})
        .then(()=>{this.activeBurger = "";
          this.tutoset("profil");
        })
        .catch(error=>{
          this.activeBurger = "";
        });
      else
        this.$router.push({name: "profilWithClub", params: {id: this.club.id}})
         .then(()=>{this.activeBurger = "";
         this.tutoset("profilWithClub");})
        .catch(error=>{
          this.activeBurger = "";
        });
    },
    goSearchClub: function() {
      this.$router.push({name: 'visit'}).catch(err=>{})
      .then(()=>{this.activeBurger = "";
       this.tutoset("visit");
      })
      .catch(error=>{
         
      });
    },
    goClub: function() {
     
      this.$router.push({name: "club"})
      .then(()=>{this.activeBurger = "";this.tutoset("club");})
      .catch(error=>{
         this.activeBurger = "";
      });
    },
    goViewClub: function() {
      
      this.$router.push({name: "viewClub", params: {id: this.club.id}})
      .then(()=>{this.activeBurger = ""; this.tutoset("viewClub");})
      .catch(error=>{
        this.activeBurger = "";
      });
    },
    goSaison: function() {
     
      this.$router.push({name: "saison", params: {id: this.club.id}})
      .then(()=>{this.activeBurger = "";this.tutoset("saison");})
      .catch(error=>{
        this.activeBurger = "";
      });
    },
    goConcours() {
      
        this.$router.replace({name: "concours", params: {id: this.club.id}})
        .then(()=>{this.activeBurger = "";this.tutoset("concours");})
        .catch(error=>{
          this.activeBurger = "";
        });
    },
    goMembres: function() {
     
      this.$router.push({name: "membres", params: {id: this.club.id}})
      .then(()=>{this.activeBurger = "";this.tutoset("membres");})
      .catch(error=>{
        this.activeBurger = "";
      });
      
    },
   
    payment: function() {
   
      this.activeBurger = "";
      if (this.club==null)
        this.$router.push({name: "payment"})
        .then(()=>{this.activeBurger = "";})
        .catch(error=>{
          this.activeBurger = "";
        })
      
      
      else
        this.$router.push({name: "paymentWithClub", params: {id: this.club.id}})
        .then(()=>{this.activeBurger = "";})
        .catch(error=>{
          this.activeBurger = "";
        });
    },
    home: function() {
      
          this.$router.push({name: "home"})
            .then(()=>{this.activeBurger = "";})
            .catch(error=>{
              this.activeBurger = "";
            });
    },
    login: function() {
        this.$router.push({name: "login"})
          .then(()=>{this.activeBurger = "";})
          .catch(error=>{
            this.activeBurger = "";
          });
    },
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch('init',()=>{
            this.$router.push({name: "home"}).catch(error=>{
              this.activeBurger = "";
            });
          });
       });
    },
    getRole(club) {
            return this.$getRole();
    },
    upload() {

    }
  },
  
  mounted: function() {
   
    if (typeof(this.idClub)=="undefined")
        this.club = null;
      else {
        this.$bind("club", firebase_api.api.getDb().collection('club').doc(this.idClub))
      }
    this.$bind("historiques", firebase_api.api.getDb().collection("user").
            doc(this.$store.getters.getUser.email).collection("creditsOffer"))
  }
};
</script>